(function () {
  'use strict';

  angular.module('ringbaPortal').controller('CampaignController', CampaignController);

  function CampaignController(
    _,
    $scope,
    $stateParams,
    $translate,
    $filter,
    $uibModal,
    accountsService,
    affiliateService,
    campaignServiceNew,
    featureFlags,
    ivrService,
    infoService,
    tagService,
    toaster,
    utils,
    userSettingsService,
    utilities,
    VuexStore
  ) {
    'ngInject';

    const vm = this;

    const render = utilities.safeApply.bind($scope);

    const DEFAULT_DIAL_ATTEMPTS = 3;

    vm.campaignForm = {};
    vm.campaignCountry = null;
    vm.currentSpamFilterSettings = null;
    vm.isPublisherEnrolledInOffer = undefined;
    vm.isRtbEnabled = false;
    vm.passThroughBid = null;
    vm.isAdmin = accountsService.isAdmin();
    vm.isStrikePriceScheduleEnabled = false;
    vm.pendingStrikePriceSchedule = null;
    vm.accountTimeZoneId = '';

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.updateCampaign = updateCampaign;
    vm.hasAccess = accountsService.hasAccess;
    // Read per digest: flags reload asynchronously on account switch.
    vm.hasRingTreeFeature = function () { return featureFlags.isOn('pingtree'); };
    vm.reloadCampaign = reloadCampaign;
    vm.shouldShowNumberPool = shouldShowNumberPool;
    vm.setDefaultPayout = setDefaultPayout;
    vm.updateDefaultPayoutSettings = updateDefaultPayoutSettings;
    vm.hideCampaignNextStepPanel = hideCampaignNextStepPanel;
    vm.saveSelectedIVRTree = saveSelectedIVRTree;
    vm.saveStrikePriceSchedule = saveStrikePriceSchedule;
    vm.onStrikePriceScheduleUpdated = onStrikePriceScheduleUpdated;
    vm.toggleRouteCampaignToIVR = toggleRouteCampaignToIVR;
    vm.getCurrentSpamFilterSettings = getCurrentSpamFilterSettings;
    vm.saveSpamFilterSettings = saveSpamFilterSettings;
    vm.setOfferForStatus = setOfferForStatus;
    vm.affiliateNotPartOfOffer = affiliateNotPartOfOffer;
    vm.onOfferExpire = onOfferExpire;
    vm.showOfferTab = showOfferTab;
    vm.showCampaignTab = showCampaignTab;
    vm.saveTCPAShieldSetting = saveTCPAShieldSetting;
    vm.setCampaignTags = setCampaignTags;
    vm.onSelectAffiliate = onSelectAffiliate;
    vm.saveShareableTagsSetting = saveShareableTagsSetting;
    vm.cancelCallRoutingUpdate = cancelCallRoutingUpdate;
    vm.confirmCallRoutingUpdate = confirmCallRoutingUpdate;
    vm.onCampaignTabSelected = onCampaignTabSelected;

    async function onInit() {
      vm.isAffiliate = accountsService.isAffiliate();
      vm.isAffiliateManager = accountsService.isAffiliateManager();

      vm.managerInReadOnlyGroup = VuexStore.getters['inReadOnlyGroup'];

      vm.campaignId = ($stateParams.campaignId) ? $stateParams.campaignId : null;
      if (vm.campaignId) {
        if (featureFlags.isOn('rtb')) {
          utilities.ngVueEventBus.$on(utilities.ngVueEvents.EVENT_CAMPAIGNS_UPDATED, _renderCampaignsUpdated);
          VuexStore.dispatch('dynamicInboundCalls/pullDynamicInboundCallsCampaignSettings', { campaignId: vm.campaignId }).catch(function () {
            toaster.pop('error', 'Unable to load campaign RTB settings');
          });
        }
        _loadCampaign(vm.campaignId);
        _checkNextStepsToBeShown(vm.campaignId);

        if (!vm.isAffiliate) {
          _loadIVRTrees();
        }
      }
      _checkToShowOffersTab();

      vm.payoutWidgetHeaderForAffiliateOrManager = _getPayoutWidgetHeaderTranslation(vm.isAffiliate, vm.isAffiliateManager);

      vm.statsSubId = vm.campaignId;
      if (!vm.isAffiliate) {
        vm.statsType = 'campaign';
      } else {
        vm.statsType = 'campaignAffiliate';
      }
      vm.accountTimeZoneId = accountsService.currentAccount ? accountsService.currentAccount.timeZoneId : '';
      _loadTimeZones();

      await _loadTags();
    }

    function onDestroy() {
      utilities.ngVueEventBus.$off(utilities.ngVueEvents.EVENT_CAMPAIGNS_UPDATED, _renderCampaignsUpdated);
    }

    function updateDefaultPayoutSettings(event) {
      vm.campaignPayoutSettings = event.payoutSettings;
    }

    function setDefaultPayout() {
      return campaignServiceNew.setDefaultPayout(accountsService.currentAccountId, vm.campaignId, vm.campaignPayoutSettings).then(function (response) {
        if (vm.currentCampaign) {
          vm.currentCampaign.defaultPayout = response.data.campaign.defaultPayout;
        }
        toaster.pop('success', $filter('translate')('CAMPAIGN_DEFAULT_PAYOUT_UPDATED'));
      }).catch(utils.errorHandler);
    }

    function reloadCampaign() {
      _loadCampaign(vm.campaignId);
    }

    function shouldShowNumberPool() {
      return vm.currentCampaign && vm.currentCampaign.pool && vm.campaignCountry;
    }

    function updateCampaign() {
      if (vm.currentCampaign.spamDetection)
        delete vm.currentCampaign.spamDetection;

      const rpcItem = vm.currentCampaign.rpcItem;
      const overrideRpcSetting = vm.currentCampaign.overrideRpcSetting;

      if (vm.currentCampaign.rpcItem)
        delete vm.currentCampaign.rpcItem;
      if (vm.currentCampaign.overrideRpcSetting)
        delete vm.currentCampaign.overrideRpcSetting;

      _sanitizeLegacyRpcSetting(overrideRpcSetting, rpcItem);

      return _updateCampaign(vm.currentCampaign, rpcItem);
    }

    async function _updateCampaign(campaign, rpcItem) {
      try {
        const response = await campaignServiceNew.updateCampaign(accountsService.currentAccountId, campaign);
        await _handleLinkRpc(campaign, rpcItem);
        toaster.pop('success', $filter('translate')('CAMPAIGN_UPDATE_SUCCESS'));
        return response.data.campaign;
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    function hideCampaignNextStepPanel() {
      vm.showCampaignNextSteps = false;
    }

    function saveSelectedIVRTree() {
      return campaignServiceNew.addIVR(accountsService.currentAccountId, vm.currentCampaign.id, vm.selectedIVRTree.id)
        .then(_hydrateCampaign)
        .then(function () {
          toaster.pop('success', $filter('translate')('CAMPAIGN_CALL_FLOW_TREE_UPDATED'));
        }).catch(utils.errorHandler);
    }

    function _strikePriceScheduleOf(campaign) {
      return (campaign.strikePriceSettings && campaign.strikePriceSettings.schedule) || [];
    }

    // The campaign data is the only source of truth for the toggle: a null or empty
    // schedule reads as off, anything else as on.
    function _hydrateStrikePriceSchedule(schedule) {
      vm.isStrikePriceScheduleEnabled = !!(schedule && schedule.length);
      vm.pendingStrikePriceSchedule = null;
    }

    function onStrikePriceScheduleUpdated(sparseSchedule) {
      vm.pendingStrikePriceSchedule = sparseSchedule;
    }

    function saveStrikePriceSchedule() {
      let schedule;

      // An empty schedule is what "off" means on the server, so toggling off and saving clears it.
      if (!vm.isStrikePriceScheduleEnabled) {
        schedule = [];
      } else if (vm.pendingStrikePriceSchedule != null) {
        schedule = vm.pendingStrikePriceSchedule;
      } else {
        schedule = _strikePriceScheduleOf(vm.currentCampaign);
      }

      return campaignServiceNew
        .updateStrikePriceSchedule(accountsService.currentAccountId, vm.currentCampaign.id, schedule)
        .then(function (response) {
          const updated = response.data.campaign;
          vm.currentCampaign.strikePriceSettings = updated.strikePriceSettings;
          _hydrateStrikePriceSchedule(_strikePriceScheduleOf(updated));
          toaster.pop('success', $filter('translate')('CAMPAIGN_UPDATE_SUCCESS'));
        })
        .catch(utils.errorHandler);
    }

    function toggleRouteCampaignToIVR(ivr, type, label) {
      // The routing buttons are clickable before the campaign GET returns.
      if (!vm.currentCampaign || !vm.currentCampaign.routingType) {
        return;
      }

      // If there is no change, no need to launch modal, and reset ivr hook
      if ((vm.currentCampaign.routingType.toLowerCase() === type.toLowerCase() && !vm.currentCampaign.callIVRTree) || (ivr && vm.currentCampaign.callIVRTree)) {
        vm.routeCampaignToIVR = vm.currentCampaign.callIVRTree && vm.selectedIVRTree;
        return;
      }

      // If ivr is true, set value and return, no need to launch the modal
      if (ivr) {
        vm.routeCampaignToIVR = ivr;
        return;
      }

      // All other scenarios, set the new call route object and launch modal presenting user with two options, cancel or update.
      vm.newCallRouteObj = {
        ivr: ivr,
        type: type,
        label: label
      };

      // Set the current call routing label for use in the modal, the names and labels are a bit mismatched, so it requires some extra work
      vm.currentCallRouteLabel = !vm.currentCampaign.callIVRTree ? (vm.currentCampaign.routingType == 'PRIORITY' ? 'Priority (Standard)' : 'Predictive') : 'Call Flow';
      vm.confirmCallRoutingModal = $uibModal.open({
        templateUrl: '/scripts/components/campaigns/confirm-call-routing.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'md'
      });

    }

    function cancelCallRoutingUpdate() {
      // If the modal exists, on cancel of attempting to update the call routing, reset the newCallRouteObj, reset the routeCampaignToIVR, close modal, and return the selected option to the original
      if (vm.confirmCallRoutingModal) {
        vm.newCallRouteObj = null;
        vm.routeCampaignToIVR = vm.currentCampaign.callIVRTree && vm.selectedIVRTree;
        vm.confirmCallRoutingModal.close();
        vm.routeType = !vm.routeCampaignToIVR ? (vm.currentCampaign.routingType == 'PRIORITY' ? 'standard' : 'rpc') : 'ivr';
      }
    }
    function confirmCallRoutingUpdate() {
      if (vm.newCallRouteObj) {
        vm.isUpdatingCallRoute = true;
        vm.routeCampaignToIVR = vm.newCallRouteObj.ivr;

        if (!vm.routeCampaignToIVR && vm.currentCampaign.routingType !== vm.newCallRouteObj.type) {
          campaignServiceNew.setRoutingType(accountsService.currentAccountId, vm.currentCampaign.id, vm.newCallRouteObj.type)
            .then(_hydrateCampaign)
            .then(function () {
              toaster.pop('success', $filter('translate')('CAMPAIGN_IVR_TREE_REMOVED'));
            })
            .catch(utils.errorHandler)
            .finally(function () {
              vm.confirmCallRoutingModal.close();
              vm.isUpdatingCallRoute = false;
            });
        }

        if (vm.currentCampaign.ivrEnabled && !vm.routeCampaignToIVR && !!vm.selectedIVRTree) {

          campaignServiceNew.removeIVR(accountsService.currentAccountId, vm.currentCampaign.id)
            .then(_hydrateCampaign)
            .then(function () {
              toaster.pop('success', $filter('translate')('CAMPAIGN_IVR_TREE_REMOVED'));
            })
            .catch(utils.errorHandler)
            .finally(function () {
              vm.confirmCallRoutingModal.close();
              vm.isUpdatingCallRoute = false;
            });
        }
      }
    }

    function saveSpamFilterSettings(settings) {
      const campaign = {
        id: vm.currentCampaign.id,
        completed: vm.currentCampaign.completed,
        spamDetection: settings,
      };
      const rpcItem = vm.currentCampaign.rpc ? vm.currentCampaign.rpc : vm.currentCampaign.rpcItem;

      return _updateCampaign(campaign, rpcItem)
        .then(function (campaign) {
          vm.currentSpamFilterSettings = getCurrentSpamFilterSettings(campaign.spamDetection);
        });
    }

    function saveTCPAShieldSetting(settings) {
      const campaign = {
        id: vm.currentCampaign.id,
        completed: vm.currentCampaign.completed,
        filterCallsThroughTCPAShield: settings.filterCallsThroughTCPAShield,
        playTCPAWarningMessage: settings.playTCPAWarningMessage,
      };
      const rpcItem = vm.currentCampaign.rpc ? vm.currentCampaign.rpc : vm.currentCampaign.rpcItem;

      return _updateCampaign(campaign, rpcItem);
    }

    function saveShareableTagsSetting() {
      _processShareableTags();
      const campaign = {
        id: vm.currentCampaign.id,
        completed: vm.currentCampaign.completed,
        shareableTagSetting: vm.currentCampaign.shareableTagSetting
      };
      const rpcItem = vm.currentCampaign.rpc ? vm.currentCampaign.rpc : vm.currentCampaign.rpcItem;

      return _updateCampaign(campaign, rpcItem);
    }

    function setOfferForStatus(offer) {
      vm.offerForStatus = offer;
      vm.offerNumberRestrictions = offer && offer.numberRestrictions;
      if (vm.isAffiliate && offer) {
        vm.isPublisherEnrolledInOffer = offer.offerParticipationStatus && offer.offerParticipationStatus === 'enrolled';
        vm.isLoadingOffers = false;
        _setPageTitle(vm.isPublisherEnrolledInOffer, offer && offer.name, vm.currentCampaign && vm.currentCampaign.name);
      }
    }

    function affiliateNotPartOfOffer() {
      vm.isPublisherEnrolledInOffer = false;
      vm.isLoadingOffers = false;
      _setPageTitle(vm.isPublisherEnrolledInOffer, '', vm.currentCampaign && vm.currentCampaign.name);
    }

    function onOfferExpire() {
      if (vm.offerForStatus) {
        vm.offerForStatus.offerState = 'expired';
        vm.offerForStatus = angular.copy(vm.offerForStatus);
      }
    }

    function onSelectAffiliate() {
      vm.statsSubId = vm.campaignId + '-' + vm.selectedAffiliate.id;
    }

    function showOfferTab() {
      vm.activeTab = 2;
    }

    function showCampaignTab() {
      vm.activeTab = 0;
    }

    function _loadCampaign(campaignId) {
      campaignServiceNew.getCampaign(accountsService.currentAccountId, campaignId, true)
        .then(_hydrateCampaign)
        .then(_loadRTBSettings)
        .catch(utils.errorHandler);
    }



    function _checkNextStepsToBeShown(campaignId) {
      userSettingsService.getUserSettings().then(function (userSettings) {
        vm.userSettings = userSettings;
        vm.showCampaignNextSteps = !userSettings.neverShowCampaignNextSteps && userSettings.campaignNextSteps && userSettings.campaignNextSteps[campaignId];
      });
    }

    function _loadIVRTrees() {
      ivrService.getTreesUI(accountsService.currentAccountId, false, true).then(function (response) {
        vm.ivrTrees = response.ivrTrees;
      });
    }

    function getCurrentSpamFilterSettings(filterSettings) {
      if (!filterSettings && vm.currentCampaign)
        filterSettings = vm.currentCampaign.spamDetection;

      if (!filterSettings)
        return {};

      return {
        blockDuplicatesForSeconds: filterSettings.blockDuplicatesForSeconds,
        trackAnonymous: filterSettings.trackAnonymous
      };
    }

    function _hydrateCampaign(response) {
      vm.currentCampaign = response.data.campaign;
      if (response.data.integrationSettings) {
        vm.integrationSettingsIdsMap = response.data.integrationSettings;
      }

      if (typeof vm.currentCampaign.defaultPayout !== 'undefined') {
        vm.campaignPayoutSettings = angular.copy(vm.currentCampaign.defaultPayout);
        vm.payoutCaps = affiliateService.initializePayoutCaps(vm.campaignPayoutSettings);
      } else {
        vm.campaignPayoutSettings = { isRevShare: false };
      }

      vm.currentCampaign.recordSetting = vm.currentCampaign.recordSetting || { record: false, recordFromAnswer: false, trimSilence: false };
      vm.currentCampaign.dialSettings = vm.currentCampaign.dialSettings || { dialAttempts: DEFAULT_DIAL_ATTEMPTS };
      vm.currentCampaign.rtb = { enabled: vm.isRtbEnabled, passThroughBid: vm.passThroughBid };

      vm.campaignCountry = campaignServiceNew.countryCodeForCampaign(vm.currentCampaign, null);
      vm.selectedIVRTree = angular.copy(vm.currentCampaign.callIVRTree);
      vm.routeCampaignToIVR = !!vm.selectedIVRTree;
      vm.routeType = !vm.routeCampaignToIVR ? (vm.currentCampaign.routingType == 'PRIORITY' ? 'standard' : 'rpc') : 'ivr';
      _hydrateStrikePriceSchedule(_strikePriceScheduleOf(vm.currentCampaign));
      _initializeCampaignTags(response.data.jsTags);

      vm.currentSpamFilterSettings = vm.currentSpamFilterSettings || getCurrentSpamFilterSettings(vm.currentCampaign.spamDetection);
      // Decide to show offer name on the header or not
      _showOfferName(vm.isAffiliate, vm.currentCampaign);

      if (vm.isAffiliateManager && vm.currentCampaign.affiliates && vm.currentCampaign.affiliates.length > 0) {
        vm.selectedAffiliate = vm.currentCampaign.affiliates[0];
        onSelectAffiliate();
      }

      // Set page title
      _setPageTitle(vm.isPublisherEnrolledInOffer, '', vm.currentCampaign && vm.currentCampaign.name);

    }

    function _checkToShowOffersTab() {
      if ($stateParams.showOffer) {
        showOfferTab();
      }
    }

    function setCampaignTags(jsTags) {
      if (vm.currentCampaign) {
        vm.currentCampaign.jsTags = jsTags;
      }
    }

    function _getPayoutWidgetHeaderTranslation(isAffiliate, isAffiliateManager) {
      if (isAffiliateManager) {
        return $translate.instant('CAMPAIGN_STEP_PAYOUT_HEADER');
      } else if (isAffiliate) {
        return $translate.instant('CAMPAIGN_MY_PAYOUT_HEADER');
      }
    }

    function _initializeCampaignTags(jsTags) {
      if (vm.currentCampaign && jsTags)
      {
        vm.currentCampaign.jsTags = [];
        // Associative array to improve the assignment from nxm to n
        const jsTagAffiliateMap = {};

        if (vm.currentCampaign.affiliateNumbers) { // null check to prevent issues when campaign doesnt have affiliate numbesr
          for (let i = 0; i < vm.currentCampaign.affiliateNumbers.length; i++) {
            const affiliate = vm.currentCampaign.affiliateNumbers[i];
            jsTagAffiliateMap[affiliate.jsTagId] = affiliate;
          }
        }
        _.forOwn(jsTags, function (value) {
          const number = jsTagAffiliateMap[value.id];
          value.number = number;
          if (value.previousNumber && value.previousNumber.e164Number) {
            value.e164ExistingNumber = value.previousNumber.e164Number;
          }
          vm.currentCampaign.jsTags.push(value);
        } );
      }
    }


    function _showOfferName(isAffiliate, campaign) {
      if (isAffiliate && campaign.offerId && typeof vm.isPublisherEnrolledInOffer === 'undefined') {
        vm.isLoadingOffers = true;
      }
    }

    function _setPageTitle(isPublisherEnrolledInOffer, offerName, campaignName) {
      if (!vm.isLoadingOffers) {
        vm.pageTitle = isPublisherEnrolledInOffer ? offerName : campaignName;
      }
    }

    function _renderCampaignsUpdated() {
      vm.isRtbEnabled = featureFlags.isOn('rtb') && VuexStore.getters['dynamicInboundCalls/enabled'](vm.campaignId);
      vm.rtbStatus = VuexStore.getters['dynamicInboundCalls/setupVal'](vm.campaignId) ? _getStatusFromRtb(vm.isRtbEnabled) : 'deactivated';
      vm.passThroughBid = VuexStore.getters['dynamicInboundCalls/passThroughBid'](vm.campaignId);
      if (vm.currentCampaign) vm.currentCampaign.rtb = { enabled: vm.isRtbEnabled, passThroughBid: vm.passThroughBid };
      render();
    }

    function _getStatusFromRtb(rtbEnabled) {
      return rtbEnabled ? 'enabled' : 'disabled';
    }

    function _addRtbId(affiliate) {
      affiliate.rtbId = VuexStore.getters['dynamicInboundCalls/rtbId'](vm.campaignId, affiliate.id);
    }

    function _hydrateRtbData() {
      if (!featureFlags.isOn('rtb') || !vm.isRtbEnabled || !vm.currentCampaign) {
        return;
      }

      // Hydrate RTB info for affiliates
      (vm.currentCampaign.affiliates || []).forEach(_addRtbId);
      
      // Hydrate RTB info for affiliateNumbers
      (vm.currentCampaign.affiliateNumbers || []).forEach(function(affNum) {
        _addRtbId(affNum.affiliate);
      });
    }

    function _loadRTBSettings() {
      _renderCampaignsUpdated();

      if (featureFlags.isOn('rtb') && vm.isRtbEnabled && vm.currentCampaign && (!vm.isAffiliate || vm.isAffiliateManager) && vm.currentCampaign.affiliates) {
        VuexStore.dispatch('dynamicInboundCalls/pullRTBAllPubSettings', { campaignId: vm.campaignId })
          .then(function() {
            _hydrateRtbData(); 
          })
          .catch(utils.errorHandler);
      }
    }

    function _loadTimeZones() {
      infoService.getDisplayTimezone(accountsService.currentAccount.timeZoneId)
        .then(function (response) {
          vm.timezone = response;
        })
        .catch(utils.errorHandler);
    }

    async function _loadTags() {
      try {
        const response = await tagService.getTags(accountsService.currentAccountId);
        vm.availableTags = response.data;
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    function _processShareableTags() {
      vm.currentCampaign.shareableTagSetting = tagService.getShareableTags(vm.currentCampaign.shareableTagSetting, vm.availableTags);
    }

    function _handleLinkRpc(campaign, rpcItem) {
      const campaignId = campaign && campaign.id;
      if (campaignId) {
        if (rpcItem && rpcItem.id) {
          if (rpcItem.id.substr(0, 2) === 'CA' && rpcItem.id.substr(-4) === 'LINK') return;
          if (!vm.currentCampaign.rpc || rpcItem.id !== vm.currentCampaign.rpc.id) {
            return campaignServiceNew.link(accountsService.currentAccountId, campaignId, rpcItem.id, 'RPC');
          }
        }
      }
    }

    function _sanitizeLegacyRpcSetting(overrideRpcSetting, rpcItem) {
      // If there isn't an existing rpc object and a user created predictive routing config is selected, null out the rpcSetting object
      if (!vm.currentCampaign.rpc && rpcItem?.id) {
        vm.currentCampaign.rpcSetting = null;
      }
      // If migrated predictive routing config was enabled but a user created predictive routing config is selected, null out the rpcSetting object
      if ((vm.currentCampaign.rpc?.id && rpcItem?.id) && (vm.currentCampaign.rpc.id !== rpcItem.id)) {
        vm.currentCampaign.rpcSetting = null;
      }
      // If user selects to use parent RPC settings, null out the rpcSetting object and reset priorityBump
      if (!overrideRpcSetting) {
        vm.currentCampaign.rpcSetting = null;
      }
    }

    function onCampaignTabSelected(page) {
      if (window.clarity) {
        window.clarity('set', 'page_view', page);
      }
    }

  }
})();
